import styled from 'styled-components';
import { Button } from '@design-system';

export const StyledTranslationButton = styled(Button.Tertiary)`
  .button_component {
    padding: 0;
  }
`;
